import { SelectOption } from '@/components/AntdForm/antd-components.def';
import dayjs from 'dayjs';

export const stringArrayToSelectOptions = (arr: string[]): SelectOption[] => {
  return arr.map((x) => {
    return {
      label: x,
      value: x,
    } as SelectOption;
  });
};

export const joinUniqueValues = (values: Array<string | null | undefined>) => {
  const uniqueValues = Array.from(
    new Set(values.map((value) => value?.trim()).filter((value): value is string => !!value)),
  );

  return uniqueValues.length > 0 ? uniqueValues.join(', ') : null;
};

export const toDisplayNum = (value?: number | null, maximumFractionDigits = 2) => {
  if (value == undefined) return undefined;

  return new Intl.NumberFormat('default', {
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(value);
};

export const toDateTime = (value: string): string => {
  if (!value) return '';

  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
};
